import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ca from './ca'
import de from './de'
import en from './en'
import es from './es'
import fr from './fr'
import it from './it'

Vue.use(VueI18n)

const messages = {
  es,
  en,
  ca,
  it,
  de,
  fr,
}

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'es', // set locale
  fallbackLocale: 'es', // set fallback locale
  messages, // set locale messages
})

export default i18n
